import { usePolling, type UsePollingReturn } from "@/common/hooks/use-polling";

import { fetchRagQualityMetrics } from "./rag-quality-api";
import type { RagQualityMetrics } from "./rag-quality-types";

export interface UseRagQualityReturn {
  metrics: RagQualityMetrics | null;
  isLoading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useRagQuality(): UseRagQualityReturn {
  const polling: UsePollingReturn<RagQualityMetrics> = usePolling(fetchRagQualityMetrics, {
    fallbackErrorMessage: "Failed to load RAG quality metrics",
  });

  return {
    metrics: polling.data,
    isLoading: polling.isLoading,
    error: polling.error,
    refresh: polling.refresh,
  };
}
